import PropTypes from "prop-types"

const createIntegerPropType = (minimum) => (props, propName, componentName) => {
    const value = props[propName]

    if (value === undefined) return null

    if (!Number.isInteger(value) || value < minimum) {
        return new Error(`${componentName}: a propriedade ${propName} deve ser um número inteiro maior ou igual a ${minimum}.`)
    }

    return null
}

export const dynamicTextareaPropTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func.isRequired,
    minRows: PropTypes.number,
    maxRows: createIntegerPropType(1),
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    error: PropTypes.bool,
    helperText: PropTypes.string,
    inputProps: PropTypes.shape({
        placeholder: PropTypes.string,
    }),
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
}

export const characterLimitPropType = createIntegerPropType(0)
